import { render } from "./GeneralTab.vue?vue&type=template&id=e8a2ff0a&scoped=true"
import script from "./GeneralTab.vue?vue&type=script&lang=ts"
export * from "./GeneralTab.vue?vue&type=script&lang=ts"

import "./GeneralTab.vue?vue&type=style&index=0&id=e8a2ff0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e8a2ff0a"

export default script